<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oLM9lm/tc-custom/9781466829763.jpg?1732052121929" alt="This image is the cover for the book Rogue's Bride, The Turnbridge Sisters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rogue's Bride, The Turnbridge Sisters
      </h1>
      <p class="bookDescription body article font2">
        <p>Tristan Townsend has come home to London to assume his duties as the Marquis of Lockwood after all the men in his family have died. Desperate to rid himself of the "Lockwood curse" and restore his family's honor, marriage is the furthest thing from Tristan's mind…until he lays eyes on an enchanting stranger and vows to make her his… <br/><br/>Lady Simone Turnbridge—beautiful, bold, and with a scandalous past—is not eager to be some wealthy man's bride. Some men want her hand in marriage; others merely want her in their beds. She mocks them all with a twinkle in her eye, knowing not one of them can tame her… <br/><br/>Tristan will do anything to have Simone in his bed <i>and</i> his ring on her finger. Simone, who has sworn to let no man control her, is held in thrall by her fascination with this forbidden Lockwood. But it's too late to walk away now—when the promise of  passion is so wanton, wicked, and thoroughly wonderful….</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leslie Lafoy
      </h2>
      
      <p class="authorDescription body article"><P><B>LESLIE LaFOY</B> grew up loving to read and living to write. (This was a significant factor in her becoming the unofficial poster child of over-education. In the Liberal Arts no less.) After teaching high school history for many years, she focused her creative energies on her life-long dream of writing full time. When not made completely oblivious to reality by her current work in progress, she dabbles in every handicraft known to womankind and, twice a week and ever other weekend, dons her cape to be Hockey and Lacrosse Mom.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0aff1ac8